import { dispatch } from "../store/store";
import {
  addPharmacyNotificationData,
  setIsPharmacyNotificationsLoadingData,
} from "@/features/pharmacyNotificationsSlice/pharmacyNotificationsSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "pharmacyNotifications";

// #region State Setters
export const setIsPharmacyNotificationsLoadin = (isLoading) => {
  dispatch(setIsPharmacyNotificationsLoadingData(isLoading));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const addPharmacyNotification = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPharmacyNotificationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

// #endregion
